import React from "react";
import DateLabel from "./DateLabel";

const WeeklyHeader = ({ date, style, showMonth }) => {
  return <DateLabel date={date} style={style} showMonth={showMonth} />;
};

export default WeeklyHeader;
